var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webHeader',{attrs:{"routerName":_vm.routerName}}),_c('router-view',{on:{"getCurrentRouter":_vm.getCurrentRouter}}),_c('div',{class:_vm.isOpenLoginDialog === true?'sign-show':''},[_c('loginDialog',{ref:"loginDialog"})],1),_c('web-robot'),_c('web-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }